/** Step IDs for the Design Confidence Checker stepper. Order matches the user flow. */
export const STEP_UPLOAD = 1;
export const STEP_RESULTS = 2;
export const STEP_MESSAGE = 3;
export const STEP_SOURCE_UPLOAD = 4;
